export class EventConstants {
    public static readonly CONTAINER_CHANGED = 'XBS-Container-Changed';
}
